import EventBus from '..'

export interface ProgressState {
  type?: string
  show?: boolean
  progress?: number
}

export class ProgressEventBus extends EventBus<ProgressState> {
  name(): string {
    return 'progressEventBus'
  }
}

export default new ProgressEventBus()
